<template>
  <el-select
    v-model="filter.zone"
    :loading="isLoading"
    :remote-method="zoneQuerySearch"
    placeholder="Leave it blank for all Zones"
    :trigger-on-focus="false"
    class="w-100"
    :debounce="500"
    filterable
    clearable
    remote
    value-key="id"
    @change="handleSelectZone"
  >
    <el-option
      v-for="item in filter.zones"
      :key="item.id"
      :label="item.desc"
      :value="item"
    />
  </el-select>
</template>

<script>
export default {

  data () {
    return {
      isLoading: false,
      filter: {

        zones: [],
        zone: {
        }

      },
      isShowing: false,
      isSaving: false
    }
  },

  methods: {

    zoneQuerySearch (queryString) {
      this.$sdk.dictionary_zone.list(builder => {
        this.openLoading()
        this.isLoading = true
        builder.filters = {
          dictionary_zone_carrier_or_null: this.$route.params.carrierId,
          dictionary_zone_desc: queryString
        }
      }).then(res => {
        this.filter.zones = (res)
      })
        .finally(() => {
          this.closeLoading()
        })
    },
    handleSelectZone (item) {
      this.filter.zone = item
      this.$emit('update', this.filter)
    },
    openLoading () {
      this.isLoading = true
    },
    closeLoading () {
      this.isLoading = false
    },
    reset () {
      this.filter = {
        zones: [],
        zone: {
        }

      }
      this.carrier = {
        name: null
      }
    },
    getId () {
      return this.filter.zone.id
    },
    getName () {
      if (this.filter.zone) {
        return this.filter.zone.desc
      }
      return null
    }
  }
}
</script>

<style lang="scss" scoped>
  .padding-10 {
    padding: 10px;
  }

  ::v-deep .el-collapse-item__wrap {
    border-bottom: 0px;
  }
</style>
